import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import {
  APP_SET_NAVBAR,
  APP_SET_MENU,
  SESSION_SEVERAL_DATA,
  SESSION_USER_DATA,
  SESSION_USER_ADDRESS,
  SESSION_BUSINESS_UNIT,
  SESSION_PENDING_JOIN_REQUEST,
  SESSION_PROFILE_TYPE,
  SHOW_SNACK,
  HIDE_SNACK,
  SHOW_SNACK_ERROR,
  SHOW_SNACK_INFO,
  SET_CHAT_UNREAD,
  OPEN_CHAT_PANEL,
  CLOSE_CHAT_PANEL,
  SET_CHAT_PANEL_CONVERSATION,
  SET_CHAT_VIEWING,
  SESSION_USER_ACCESS_GROUP,
  SESSION_PERSON_TYPE,
} from "./MUTATIONS-TYPES";
import { BusinessUnits } from "@/interfaces/IBusinessUnits";
import { Persons } from "@/interfaces/IPersons";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    app: {
      snackbar: {
        value: false,
        text: "",
        type: 1,
      },
      chatUnreadCount: 0,
      chatPanelOpen: false,
      chatPanelConversationId: null as number | null,
      chatViewingConversationId: null as number | null,
    },
    sessionSeveralData: SESSION_SEVERAL_DATA,
    sessionUserAccessGroup: SESSION_USER_ACCESS_GROUP,
    sessionUser: SESSION_USER_DATA,
    sessionUserAddress: SESSION_USER_ADDRESS,
    sessionBusinessUnit: SESSION_BUSINESS_UNIT,
    sessionPendingJoinRequest: SESSION_PENDING_JOIN_REQUEST,
    sessionProfileType: SESSION_PROFILE_TYPE,
    sessionPersonType: SESSION_PERSON_TYPE,
    menuDrawer: false,
    mobileDevice: false,
    selectedBusinessUnit: new BusinessUnits.BusinessUnit(),
    tabSelected: -1,
    selectedBusisnessUnitId: 0,
    selectedProfile: 0,
    hiringProfessional: new Persons.Person(),
    distanceSearch: 10,
    _2FA: false,
    countCookies: 0,
    petData: Object,
  },

  plugins: [
    new VuexPersistence({
      storage: window.localStorage,
      reducer: (state: any) => ({
        ...state,
        app: {
          ...state.app,
          chatUnreadCount: 0,
          chatPanelOpen: false,
          chatPanelConversationId: null,
          chatViewingConversationId: null,
        },
      }),
    }).plugin,
  ],

  mutations: {
    [SHOW_SNACK](state, message) {
      state.app.snackbar.value = true;
      state.app.snackbar.text = message;
      state.app.snackbar.type = 1;
    },
    [SHOW_SNACK_ERROR](state, message) {
      state.app.snackbar.value = true;
      state.app.snackbar.text = message;
      state.app.snackbar.type = 2;
    },
    [SHOW_SNACK_INFO](state, message) {
      state.app.snackbar.value = true;
      state.app.snackbar.text = message;
      state.app.snackbar.type = 4;
    },
    [SET_CHAT_UNREAD](state, count) {
      state.app.chatUnreadCount = Number(count) || 0;
    },
    [OPEN_CHAT_PANEL](state, conversationId) {
      state.app.chatPanelOpen = true;
      state.app.chatPanelConversationId =
        conversationId == null || conversationId === "" ? null : Number(conversationId);
    },
    [CLOSE_CHAT_PANEL](state) {
      state.app.chatPanelOpen = false;
      state.app.chatPanelConversationId = null;
      // Do not clear chatViewingConversationId — Inbox may still be viewing the thread.
    },
    [SET_CHAT_PANEL_CONVERSATION](state, conversationId) {
      state.app.chatPanelConversationId =
        conversationId == null || conversationId === "" ? null : Number(conversationId);
    },
    [SET_CHAT_VIEWING](state, conversationId) {
      state.app.chatViewingConversationId =
        conversationId == null || conversationId === "" ? null : Number(conversationId);
    },
    [HIDE_SNACK](state) {
      state.app.snackbar.value = false;
    },
    sessionSeveralData(state, data) {
      state.sessionSeveralData = data;
    },
    sessionUserAccessGroup(state, data) {
      state.sessionUserAccessGroup = data;
    },
    userSessionInfos(state, data) {
      state.sessionUser = data;
    },
    sessionUserAddress(state, data) {
      state.sessionUserAddress = data;
    },
    sessionDistanceSearch(state, data) {
      state.distanceSearch = data;
    },
    session_2FA(state, data) {
      state._2FA = data;
    },
    sessionBusinessUnit(state, data) {
      state.sessionBusinessUnit = data;
    },
    sessionPendingJoinRequest(state, data) {
      state.sessionPendingJoinRequest = data;
    },
    sessionProfileType(state, data) {
      state.sessionProfileType = data;
    },
    sessionPersonType(state, data) {
      state.sessionPersonType = data;
    },
    hiringProfessional(state, data) {
      state.hiringProfessional = data;
    },
    sessionMobileDevice(state, data) {
      state.mobileDevice = data;
    },
    sessionSelectedBusisnessUnitId(state, data) {
      state.selectedBusisnessUnitId = data;
    },
    sessionBusinessUnitProfileTabSelected(state, data) {
      state.tabSelected = data;
    },
    sessionSelectedProfile(state, data) {
      state.selectedProfile = data;
    },

    logout(state) {
      //State reset
      (state.sessionSeveralData = SESSION_SEVERAL_DATA),
      (state.sessionUserAccessGroup = SESSION_USER_ACCESS_GROUP),
      (state.sessionUser = SESSION_USER_DATA),
      (state.sessionUserAddress = SESSION_USER_ADDRESS),
      (state.sessionBusinessUnit = SESSION_BUSINESS_UNIT),
      (state.sessionPendingJoinRequest = SESSION_PENDING_JOIN_REQUEST),
      (state.sessionProfileType = SESSION_PROFILE_TYPE);
      (state.sessionPersonType = SESSION_PERSON_TYPE);
      (state.selectedBusinessUnit = new BusinessUnits.BusinessUnit()),
      (state.tabSelected = 0),
      (state.selectedBusisnessUnitId = 0),
      (state.selectedProfile = 0),
      (state.distanceSearch = 10),
      (state._2FA = false);
      state.app.chatUnreadCount = 0;
      state.app.chatPanelOpen = false;
      state.app.chatPanelConversationId = null;
      state.app.chatViewingConversationId = null;

      //LocalStorage reset
      localStorage.clear();
      localStorage.setItem(APP_SET_NAVBAR, "true");
      localStorage.setItem(APP_SET_MENU, "true");
    },
  },

  actions: {
    setSessionSeveralData({ commit }, data) {
      commit("sessionSeveralData", data);
    },
    setSessionUserAccessGroup({ commit }, data) {
      commit("sessionUserAccessGroup", data);
    },
    setUserSessionInfos({ commit }, data) {
      commit("userSessionInfos", data);
    },
    setSessionUserAddress({ commit }, data) {
      commit("sessionUserAddress", data);
    },
    setDistanceSearch({ commit }, data) {
      commit("sessionDistanceSearch", data);
    },
    set_2FA({ commit }, data) {
      commit("session_2FA", data);
    },
    setSessionBusinessUnit({ commit }, data) {
      commit("sessionBusinessUnit", data);
    },
    setSessionPendingJoinRequest({ commit }, data) {
      commit("sessionPendingJoinRequest", data);
    },
    setSessionNavigationUserType({ commit }, data) {
      commit("sessionNavigationUserType", data);
    },
    setSessionProfileType({ commit }, data) {
      commit("sessionProfileType", data);
    },
    setSessionPersonType({ commit }, data) {
      commit("sessionPersonType", data);
    },
    setHiringProfessional({ commit }, data) {
      commit("hiringProfessional", data);
    },
    setIsMobileDevice({ commit }, data) {
      commit("sessionMobileDevice", data);
    },
    setSelectedBusisnessUnitId({ commit }, data) {
      commit("sessionSelectedBusisnessUnitId", data);
    },
    setsessionBusinessUnitProfileTabSelected({ commit }, data) {
      commit("sessionBusinessUnitProfileTabSelected", data);
    },
    setSessionSelectedProfile({ commit }, data) {
      commit("sessionSelectedProfile", data);
    },    

    logout({ commit }) {
      commit("logout");
    },
  },

  getters: {
    currentSessionSeveralData: ({ sessionSeveralData }) => {
      let result = JSON.parse(window.localStorage.vuex);
      if (result.sessionSeveralData != null) {
        return result.sessionSeveralData;
      } else {
        return null;
      }
    },
    currentSessionUserAccessGroup: ({ sessionUserAccessGroup }) => {
      let result = JSON.parse(window.localStorage.vuex);
      if (result.sessionUserAccessGroup != null) {
        return result.sessionUserAccessGroup[0];
      } else {
        return null;
      }
    },
    currentSessionUser: ({ sessionUser }) => {
      let result = JSON.parse(window.localStorage.vuex || "{}");
      return result.sessionUser;
    },
    currentSessionUserAddress: ({ sessionUserAddress }) => {
      let result;
      try {
        result = JSON.parse(window.localStorage.vuex);
        return result.sessionUserAddress;
      } catch (error) {
        console.log("Erro ao parsear o Json", error);
        return null;
      }
    },
    currentDistanceSearch: ({ distanceSearch }) => {
      let result;
      try {
        result = JSON.parse(window.localStorage.vuex);
        return result.distanceSearch;
      } catch (error) {
        console.log("Erro ao parsear o Json", error);
        return null;
      }
    },
    currentSessionBusinessUnit: ({ sessionBusinessUnit }) => {
      let result = JSON.parse(window.localStorage.vuex);
      if (result.sessionBusinessUnit != null) {
        return result.sessionBusinessUnit;
      } else {
        return null;
      }
    },
    currentSessionPendingJoinRequest: ({ sessionPendingJoinRequest }) => {
      return sessionPendingJoinRequest || null;
    },
    currentSessionProfileType: ({ sessionProfileType }) => {
      let result = JSON.parse(window.localStorage.vuex);
      return result.sessionProfileType;
    },
    currentSessionPersonType: ({ sessionPersonType }) => {
      let result = JSON.parse(window.localStorage.vuex);
      return result.sessionPersonType;
    },

    currentHiringProfessional: ({ hiringProfessional }) => {
      let result = JSON.parse(window.localStorage.vuex);
      return result.hiringProfessional;
    },
    
    currentSelectedBusisnessUnitId: ({ selectedBusisnessUnitId }) => {
      let result = JSON.parse(window.localStorage.vuex);
      return result.selectedBusisnessUnitId;
    },
    currentBusinessUnitProfileTabSelected: ({ tabSelected }) => {
      let result = JSON.parse(window.localStorage.vuex);
      return result.tabSelected;
    },
    currentSessionSelectedProfile: ({ selectedProfile }) => {
      let result = JSON.parse(window.localStorage.vuex);
      return result.selectedProfile;
    },
    currentIsMobileDevice: ({ mobileDevice }) => {
      let result = JSON.parse(window.localStorage.vuex);
      return result.mobileDevice;
    },
    current2FA: ({ _2FA }) => {
      let result = JSON.parse(window.localStorage.vuex);
      return result._2FA;
    },
    currentChatUnreadCount: (state) => state.app.chatUnreadCount || 0,
    currentChatViewingConversationId: (state) => state.app.chatViewingConversationId || null,
  },
});
